import { useUpload } from '../Screen/Autherised/Users/UploadContext';

const UploadWidget = () => {
    const { uploads, isWidgetOpen, setIsWidgetOpen } = useUpload();

    if (uploads.length === 0) return null;
    
    const pendingUploads = uploads.filter(u => u.state === 'uploading' || u.state === 'processing').length;

    return (
        <div className={`upload-widget ${isWidgetOpen ? 'open' : 'closed'}`}>
            <div className="widget-header" onClick={() => setIsWidgetOpen(!isWidgetOpen)}>
                <div className="header-title">
                    {pendingUploads > 0 
                        ? `Uploading ${pendingUploads} file(s)...` 
                        : 'Uploads Completed'}
                </div>
                <div className="toggle-icon">{isWidgetOpen ? '▼' : '▲'}</div>
            </div>

            {isWidgetOpen && (
                <div className="widget-body">
                    {uploads.slice().reverse().map((item) => (
                        <div key={item.id} className="upload-item">
                            <div className="item-row">
                                <span className="file-name" title={item.fileName}>{item.fileName}</span>
                            </div>
                            
                            <div className="progress-track">
                                <div 
                                    className={`progress-fill ${item.state}`} 
                                    style={{ width: `${item.progress}%` }}
                                ></div>
                            </div>
                            
                            <div className="item-footer">
                                <span className="status-text">{item.status}</span>
                                <span className={`status-badge ${item.state}`}>
                                    {item.state === 'success' ? 'Done' : item.state === 'error' ? 'Failed' : `${item.progress}%`}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default UploadWidget;